import { memo } from "react";

import { InvoiceIncomingSupplierTooltipProps } from "./types";

const Row: React.FC<{ label: string; value: React.ReactNode }> = ({ label, value }) => (
  <div className="flex justify-between gap-6 text-sm mb-1">
    <span className="text-slate-300">{label}</span>
    <span className="font-medium text-right max-w-[220px] break-all">{value}</span>
  </div>
);

/**
 * Podaci dobavljača na hover — adresa, porezni brojevi i IBAN. Isti raspored kao tooltip
 * modela vozila, da se dropdownovi ne razilaze.
 */
const InvoiceIncomingSupplierTooltip: React.FC<InvoiceIncomingSupplierTooltipProps> = (props) => {
  const { name, address, oib, vat, iban } = props;

  const hasDetails = !!(address || oib || vat || iban);
  if (!hasDetails) return null;

  return (
    <div className="min-w-[260px]">
      <div className="text-xs uppercase text-slate-400 mb-2 font-semibold">Dobavljač</div>

      {name && <Row label="Naziv" value={name} />}
      {address && <Row label="Adresa" value={address} />}
      {oib && <Row label="OIB" value={oib} />}
      {vat && <Row label="PDV ID" value={vat} />}
      {iban && <Row label="IBAN" value={iban} />}
    </div>
  );
};

export default memo(InvoiceIncomingSupplierTooltip);
